/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "surface_scan";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface ScanMode {
}

export enum ScanMode_Enum {
  INVALID = 0,
  CUSTOM = 1,
  PILLAR_AREA = 2,
  PILLAR_MESH = 3,
  PILLAR_PERIMETER = 7,
  MAP_AREA = 8,
  PILLAR_CONTOUR = 9,
  INDOOR_CONTOUR = 10,
  CYLINDER = 11,
  RADIUS_CONTOUR = 12,
  TRANSMISSION_TOWER = 15,
  MAP_CONTOUR = 16,
  TELECOM_ORBIT = 17,
  PILLAR_LONG_RANGE_CONTOUR = 18,
  SEMANTIC_TRANSMISSION_TOWER = 19,
  UNRECOGNIZED = -1,
}

export function scanMode_EnumFromJSON(object: any): ScanMode_Enum {
  switch (object) {
    case 0:
    case "INVALID":
      return ScanMode_Enum.INVALID;
    case 1:
    case "CUSTOM":
      return ScanMode_Enum.CUSTOM;
    case 2:
    case "PILLAR_AREA":
      return ScanMode_Enum.PILLAR_AREA;
    case 3:
    case "PILLAR_MESH":
      return ScanMode_Enum.PILLAR_MESH;
    case 7:
    case "PILLAR_PERIMETER":
      return ScanMode_Enum.PILLAR_PERIMETER;
    case 8:
    case "MAP_AREA":
      return ScanMode_Enum.MAP_AREA;
    case 9:
    case "PILLAR_CONTOUR":
      return ScanMode_Enum.PILLAR_CONTOUR;
    case 10:
    case "INDOOR_CONTOUR":
      return ScanMode_Enum.INDOOR_CONTOUR;
    case 11:
    case "CYLINDER":
      return ScanMode_Enum.CYLINDER;
    case 12:
    case "RADIUS_CONTOUR":
      return ScanMode_Enum.RADIUS_CONTOUR;
    case 15:
    case "TRANSMISSION_TOWER":
      return ScanMode_Enum.TRANSMISSION_TOWER;
    case 16:
    case "MAP_CONTOUR":
      return ScanMode_Enum.MAP_CONTOUR;
    case 17:
    case "TELECOM_ORBIT":
      return ScanMode_Enum.TELECOM_ORBIT;
    case 18:
    case "PILLAR_LONG_RANGE_CONTOUR":
      return ScanMode_Enum.PILLAR_LONG_RANGE_CONTOUR;
    case 19:
    case "SEMANTIC_TRANSMISSION_TOWER":
      return ScanMode_Enum.SEMANTIC_TRANSMISSION_TOWER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ScanMode_Enum.UNRECOGNIZED;
  }
}

export function scanMode_EnumToJSON(object: ScanMode_Enum): string {
  switch (object) {
    case ScanMode_Enum.INVALID:
      return "INVALID";
    case ScanMode_Enum.CUSTOM:
      return "CUSTOM";
    case ScanMode_Enum.PILLAR_AREA:
      return "PILLAR_AREA";
    case ScanMode_Enum.PILLAR_MESH:
      return "PILLAR_MESH";
    case ScanMode_Enum.PILLAR_PERIMETER:
      return "PILLAR_PERIMETER";
    case ScanMode_Enum.MAP_AREA:
      return "MAP_AREA";
    case ScanMode_Enum.PILLAR_CONTOUR:
      return "PILLAR_CONTOUR";
    case ScanMode_Enum.INDOOR_CONTOUR:
      return "INDOOR_CONTOUR";
    case ScanMode_Enum.CYLINDER:
      return "CYLINDER";
    case ScanMode_Enum.RADIUS_CONTOUR:
      return "RADIUS_CONTOUR";
    case ScanMode_Enum.TRANSMISSION_TOWER:
      return "TRANSMISSION_TOWER";
    case ScanMode_Enum.MAP_CONTOUR:
      return "MAP_CONTOUR";
    case ScanMode_Enum.TELECOM_ORBIT:
      return "TELECOM_ORBIT";
    case ScanMode_Enum.PILLAR_LONG_RANGE_CONTOUR:
      return "PILLAR_LONG_RANGE_CONTOUR";
    case ScanMode_Enum.SEMANTIC_TRANSMISSION_TOWER:
      return "SEMANTIC_TRANSMISSION_TOWER";
    case ScanMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseScanMode(): ScanMode {
  return {};
}

export const ScanMode = {
  encode(_: ScanMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScanMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScanMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ScanMode {
    return {};
  },

  toJSON(_: ScanMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ScanMode>, I>>(base?: I): ScanMode {
    return ScanMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScanMode>, I>>(_: I): ScanMode {
    const message = createBaseScanMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
